export function getFrameworkId(): string {
  return 'bootstrap4';
}
export { default as Bootstrap4Renderer, default } from './Bootstrap4Renderer.js';
